export const Hide = 'hide'

export const KeepOpen = ''
